import { Box, createColumnHelper, Table, useResponsiveValue } from 'ui'
import { CompanyPendingInvite } from 'api/company'
import { usePendingInvitesContext } from '../context/PendingInvitesProvider'
import { Pagination } from './Pagination'

const pendingColumnHelper = createColumnHelper<CompanyPendingInvite>()

const pendingColumns = [
  pendingColumnHelper.accessor('email', {
    header: 'Email',
    cell: (info) => (
      <>
        {info.getValue()}
        <Box display={['block', 'none']}>
          {info.row.original.companyRolePermission?.description}
        </Box>
      </>
    ),
  }),
  pendingColumnHelper.accessor('companyRolePermission.description', {
    header: 'Role',
  }),
]

export const PendingInvitesTable = () => {
  const tableMode = useResponsiveValue(['borderless', 'standard']) as
    | 'borderless'
    | 'standard'
  const columnsToUse = useResponsiveValue([1, 2])

  const {
    state: { invitesPage },
  } = usePendingInvitesContext()

  return (
    <Box>
      <Table
        variant={tableMode}
        columns={pendingColumns.slice(0, columnsToUse)}
        data={invitesPage}
      />
      <Pagination />
    </Box>
  )
}
